// extracted by mini-css-extract-plugin
export var text = "_x-0";